// Presentation fallback only; the backend owns image validation and list integrity.
export function getInitialImageIndex(images: string[], mainImage?: string | null): number {
  const index = mainImage ? images.indexOf(mainImage) : -1;
  return index < 0 ? 0 : index;
}
